"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachedFileInfo = void 0;
const react_1 = __importStar(require("react"));
const Text_1 = require("../../../../Text/Text");
const ComposeContext_1 = require("../../ComposeContext");
const AttachedFileList_1 = require("./AttachedFileList");
const AttachedFileListContext_1 = require("./AttachedFileListContext");
const AttachedFileInfo = ({ customFileInfoDisplay, }) => {
    var _a;
    const { uploadedFiles, maxFiles } = (0, ComposeContext_1.useCompose)();
    const { registerSubComponent } = (0, AttachedFileListContext_1.useAttachedFileList)();
    // Register this sub-component to the parent context
    (0, react_1.useEffect)(() => {
        registerSubComponent(AttachedFileList_1.AttachedFileListSubComponent.Info);
    }, []);
    let customFileInfoDisplayNodeType = ""; // Identify the type of custom render
    if (customFileInfoDisplay === null || customFileInfoDisplay === void 0 ? void 0 : customFileInfoDisplay.type) {
        customFileInfoDisplayNodeType =
            typeof customFileInfoDisplay.type === "string"
                ? customFileInfoDisplay.type
                : (_a = customFileInfoDisplay.type.displayName) !== null && _a !== void 0 ? _a : customFileInfoDisplay.type.name;
    }
    // Check accepted custom button type - semantic paragraph, styled paragraph, semantic span, styled span, accurx design lib Text
    if (customFileInfoDisplay &&
        !(customFileInfoDisplayNodeType === "p" ||
            customFileInfoDisplayNodeType === "styled.p" ||
            customFileInfoDisplayNodeType === "span" ||
            customFileInfoDisplayNodeType === "styled.span" ||
            customFileInfoDisplayNodeType === "Text")) {
        throw new Error("Only a textual element can be passed as a custom render to Compose.AttachedFileInfo");
    }
    if (uploadedFiles.length === 0) {
        return null;
    }
    const getFilesLeftCountDisplay = (fileLeftCount) => {
        return fileLeftCount === 1
            ? `You have ${fileLeftCount} file left`
            : `You have ${fileLeftCount} files left`;
    };
    if (customFileInfoDisplay) {
        return react_1.default.cloneElement(customFileInfoDisplay, {
            role: "status",
            children: getFilesLeftCountDisplay(maxFiles - uploadedFiles.length),
        });
    }
    return (react_1.default.createElement(Text_1.Text, { skinny: true, props: { role: "status" } }, getFilesLeftCountDisplay(maxFiles - uploadedFiles.length)));
};
exports.AttachedFileInfo = AttachedFileInfo;
//# sourceMappingURL=AttachedFileInfo.js.map